import React, { PureComponent } from 'react';
import classNames from 'classnames';

class PasswordField extends PureComponent {
  state = {
    showToggle: this.props.defaultValue || false,
    showHide: true
  }

  handleChange = (e) => {
    const { onChange } = this.props;
    const { value } = e.target;

    if (typeof onChange === 'function') {
      onChange(e);
    }

    this.setState({ showToggle: value ? true : false });
  }

  handleClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    const { showHide } = this.state;
    this.setState({ showHide: !showHide });
  }

  render() {
    const {
      helperText,
      htmlFor,
      labelText,
      className,
      errorMsg,
      helperTextClassName,
      labelClassName,
      ...rest
    } = this.props;

    const { showToggle, showHide } = this.state;

    return <div className={classNames('password-field', className)}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <div className={classNames('field-input password-field-input', { 'field-input--error': errorMsg })}>
        <input {...rest} className='input-element' onChange={this.handleChange} id={htmlFor} type={ showHide ? 'password' : 'text' } />
        { showToggle && <button tabIndex='-1' onClick={this.handleClick} className='toggle-password-field'>{ showHide ? 'SHOW' : 'HIDE' }</button> }
        { !errorMsg && helperText && <div className={classNames(helperTextClassName)}>{helperText}</div> }
      </div>
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

export default PasswordField;

